// Small animation helpers shared by the demo controllers.

export const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches

const CANCELLED = Symbol("cancelled")

// A cancellable script of timed steps. run() aborts any previous run: its
// pending wait() rejects and the script stops where it was. With reduced
// motion every wait resolves at once, so scripts jump to their end state.
export class Timeline {
  #run = 0

  cancel() { this.#run++ }

  async run(script) {
    const run = ++this.#run
    const wait = (ms) => new Promise((resolve, reject) =>
      setTimeout(() => (run === this.#run ? resolve() : reject(CANCELLED)), reducedMotion ? 0 : ms))
    try {
      await script(wait)
    } catch (error) {
      if (error !== CANCELLED) throw error
    }
  }
}

// Restart a one-shot CSS animation class (.is-pop, .is-bump, .is-flash)
export function replay(element, className) {
  element.classList.remove(className)
  void element.offsetWidth
  element.classList.add(className)
}

export const money = (amount) => "$" + amount.toFixed(2)

// Count a number up/down inside an element, easing out
export function tween(element, from, to, ms = 500, format = money) {
  if (reducedMotion) { element.textContent = format(to); return }
  const start = performance.now()
  const frame = (now) => {
    const k = Math.min(1, (now - start) / ms)
    element.textContent = format(from + (to - from) * (1 - (1 - k) ** 3))
    if (k < 1) requestAnimationFrame(frame)
  }
  requestAnimationFrame(frame)
}

// Open/close an element by animating its height (pair with .mock-collapse)
export function setOpen(element, open) {
  element.style.height = element.scrollHeight + "px"
  if (!open) {
    void element.offsetHeight
    element.style.height = "0px"
  }
}
